import * as React from 'react'
import {
  createStyles,
  Icon,
  Theme,
  withStyles,
  WithStyles,
  withTheme,
  WithTheme,
  Typography,
  Button
} from "@material-ui/core";
import {observable} from "mobx";
import {observer} from "mobx-react";

const styles = (theme: Theme) => createStyles({
  primaryButton: {
    width: 24,
    height: 24,
    padding: 0,
    marginLeft: 5,
    margin: 0,
    minWidth: 54,
    color: theme.palette.secondary.contrastText,
    background: theme.palette.secondary.main,
    "&:hover": {
      background: theme.palette.secondary.dark,
    },
    "&:active": {
      background: theme.palette.secondary.light,
    },
  },
  secondaryButton: {
    width: 24,
    height: 24,
    padding: 0,
    marginLeft: 5,
    margin: 0,
    minWidth: 54,
    color: theme.palette.common.white, //primary.contrastText,
    backgroundColor: theme.palette.primary.light,
    borderColor: theme.palette.primary.light,
    "&:hover": {
      background: theme.palette.primary.light,
    },
    "&:active": {
      background: theme.palette.primary.dark,
    },
  },
  tertieryButton: {
    width: 24,
    height: 24,
    padding: 0,
    marginLeft: 5,
    margin: 0,
    minWidth: 54,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      background: theme.palette.primary.light,
    },
    "&:active": {
      background: theme.palette.primary.dark,
    },
  },
  icon: {
    color: theme.palette.secondary.contrastText
  },
  label: {
    fontSize: 14,
    paddingLeft: 0,
    paddingRight: 0,
    // color: theme.palette.secondary.contrastText,
    textTransform: "uppercase"
  }
})

interface ITitleButtonProps {
  title?: string
  icon?: any
  onClick?: any
  variant?: 'primary' | 'secondary' | 'tertiary'
  className?: string
  disabled?: boolean
}

@observer
class TitleButton extends React.Component<WithStyles<typeof styles> & ITitleButtonProps & WithTheme> {
  @observable disabled = false

  componentDidMount() {
    this.disabled = this.props.disabled ? true : false
    console.log(`componentDidMount: this.disabled = ${this.disabled}`)
  }

  componentDidUpdate(prevProps: any) {
    console.log(`componentDidUpdate: this.props.disabled = ${this.disabled}`)
    if (prevProps.disabled !== this.props.disabled) {
      this.componentDidMount()
    }
  }

  onClick = (event: any) => {
    if (this.props.onClick) {
      this.props.onClick()
    }
  }

  render() {
    const { classes, icon, title, onClick, variant } = this.props

    let vari: "contained" | "outlined" | "text" = "contained"
    let className = classes.primaryButton
    if (variant === "secondary") {
      vari = "contained"
      className = classes.secondaryButton
    } else if (variant === "tertiary") {
      vari = "text"
      className = classes.tertieryButton
    }

    if (this.props.className) {
      className = this.props.className
    }

    return (
      <Button size="small"
              variant={vari}
              onClick={onClick}
              className={className}
              disabled={this.disabled}
      >
        { icon && <Icon className={classes.icon} title={title}>{icon}</Icon> }
        <Typography className={classes.label}>{title}</Typography>
      </Button>
    )
  }
}

export default withTheme((withStyles(styles)(TitleButton)))